'use client'

import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import type { PdpFeatureFlags } from 'pdp/src/types/FeatureFlags'

export const usePdpFeatureFlags = () => {
	const {
		variables: { config },
	} = useFeatureFlag<PdpFeatureFlags>(featureFlagKeys.GenesisPdp)

	return config
}
